function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Input from './Input';

var FileInput = props => {
  var onChange = props.onChange;

  var handleChange = event => {
    var files = event.target.files;
    onChange === null || onChange === void 0 ? void 0 : onChange(files);
  };

  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    type: "file",
    onChange: handleChange
  }));
};

FileInput.displayName = "FileInput";
export default FileInput;